import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const API_BASE = process.env.REACT_APP_API_BASE || "/api";

// Contenido inyectado por el servidor (index.php) para evitar el parpadeo
// de la informacion antigua en la primera carga.
const BOOTSTRAP_CONTENT =
  (typeof window !== "undefined" && window.__L2_CONTENT__ && typeof window.__L2_CONTENT__ === "object")
    ? window.__L2_CONTENT__
    : null;

const ContentContext = createContext({ content: {}, loading: true, refresh: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState(BOOTSTRAP_CONTENT || {});
  const [loading, setLoading] = useState(!BOOTSTRAP_CONTENT);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch(API_BASE + "/content", { credentials: "include" });
      const json = await res.json();
      if (json.content && typeof json.content === "object") {
        setContent(json.content);
      }
    } catch {
      // Mantener el contenido inyectado/previo si la API falla
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
}

/**
 * useContent(key, fallback) - usa un bloque editable
 */
export function useContent(key, fallback = null) {
  const { content, loading } = useContext(ContentContext);
  return { value: content[key] ?? fallback, loading };
}

/**
 * useContentRefresh() - obtiene el refresh global del CMS
 */
export function useContentRefresh() {
  return useContext(ContentContext).refresh;
}
